import { MemberAvatar } from 'common/member-avatar';
import { classnames } from 'helpers/utils';
import styles from './person-filter-row.module.scss';

export interface FilterPerson {
  id: number;
  name: string;
  email: string;
}

interface PersonFilterRowProps {
  people: FilterPerson[];
  selectedId: number | null;
  onSelect: (id: number | null) => void;
}

// Horizontal, scrollable list of the people who have shared albums with the
// current user. Clicking a chip filters the dashboard to that person; clicking
// the already-selected chip clears the filter. Design: Figma node 30081-101818.
export const PersonFilterRow = ({
  people,
  selectedId,
  onSelect,
}: PersonFilterRowProps) => {
  if (people.length === 0) return null;

  return (
    <div className={styles.row}>
      {people.map((person) => {
        const selected = person.id === selectedId;
        return (
          <button
            key={person.id}
            type="button"
            className={classnames(styles.chip, {
              [styles.chipSelected]: selected,
            })}
            aria-pressed={selected}
            onClick={() => onSelect(selected ? null : person.id)}
          >
            <MemberAvatar name={person.name || person.email} size={40} />
            <span className={styles.text}>
              <span className={styles.name}>{person.name || person.email}</span>
              {person.email && (
                <span className={styles.email}>{person.email}</span>
              )}
            </span>
          </button>
        );
      })}
    </div>
  );
};
